import * as yup from 'yup';
import { IncomeModel, IncomeOptionsDTO, IncomeType } from '../../api/useIncomeQuery';
import { getDefaultCustomBucketIndex } from '../../utils/getDefaultCustomBucketIndex';

export interface UpsertIncomeDTO extends BusinessFormValues {
  clientId: string;
  id: string | null;
  IncomeType: IncomeType;
}

export interface BusinessFormValues {
  AssociatedAssetId: string;
  Amount: number | null;
  IncomeGrowth: number | null;
  StartAge: number | null | undefined;
  EndAge: number | null | undefined;
  SelfEmployed: boolean | null;
  EndAtRetirement: boolean | null;
  OrionManagementStyleId: number | null;
  CustomBucketIndex: number | null;
}

const defaultFormValues = {
  AssociatedAssetId: '',
  Amount: null,
  IncomeGrowth: null,
  StartAge: undefined,
  EndAge: undefined,
  SelfEmployed: false,
  EndAtRetirement: false,
  OrionManagementStyleId: null,
  CustomBucketIndex: null,
};

export const dataToForm = (
  income: IncomeModel | null,
  options: IncomeOptionsDTO,
): BusinessFormValues => {
  if (!income) {
    return defaultFormValues;
  }

  return {
    AssociatedAssetId: income.AssociatedAssetId,
    Amount: income.Amount,
    IncomeGrowth: income.IncomeGrowth,
    StartAge: income.StartAge,
    EndAge: income.EndAtRetirement ? null : income.EndAge ?? undefined,
    SelfEmployed: income.SelfEmployed,
    EndAtRetirement: income.EndAtRetirement,
    OrionManagementStyleId: income.OrionManagementStyleId,
    CustomBucketIndex: getDefaultCustomBucketIndex({
      isAssetBucketingByManagementStyle: options.AssetBucketingByManagementStyle,
      customBucketIndex: income.CustomBucketIndex,
      orionManagementStyleId: income.OrionManagementStyleId,
      managementStylesOptions: options.ManagementStyles,
    }),
  };
};

export const Validation = yup.object().shape({
  AssociatedAssetId: yup
    .string()
    .nullable()
    .required('Please specify an asset.'),
  Amount: yup
    .number()
    .nullable()
    .required('Please specify a yearly amount'),
});
